export default __webpack_public_path__ + "static/media/file-arrow-up-solid.ea380b44.svg";